import { render } from "./ItemChuyenDi.vue?vue&type=template&id=17dfe32b"
import script from "./ItemChuyenDi.vue?vue&type=script&lang=js"
export * from "./ItemChuyenDi.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__